import { registerErrorReportingDataExtractionFn } from "./errorReporting/reportingDataExtraction";
export class MissingQueryParameterError extends Error {
    paramName;
    constructor(paramName) {
        super(`Parameter "${paramName}" is missing in path`);
        this.paramName = paramName;
        this.name = "MissingQueryParameterError";
        Object.setPrototypeOf(this, MissingQueryParameterError.prototype);
    }
}
registerErrorReportingDataExtractionFn((error) => {
    if (error instanceof MissingQueryParameterError) {
        const docHasReferrer = document.referrer;
        return {
            extra: {
                missingQueryParameter: error.paramName,
            },
            noReport: !docHasReferrer,
        };
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWlzc2luZ1F1ZXJ5UGFyYW1ldGVyRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZXJyb3JzL01pc3NpbmdRdWVyeVBhcmFtZXRlckVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxzQ0FBc0MsRUFBRSxNQUFNLDBDQUEwQyxDQUFDO0FBRWxHLE1BQU0sT0FBTywwQkFBMkIsU0FBUSxLQUFLO0lBQ25DLFNBQVMsQ0FBUztJQUVsQyxZQUFtQixTQUFpQjtRQUNsQyxLQUFLLENBQUMsY0FBYyxTQUFTLHNCQUFzQixDQUFDLENBQUM7UUFDckQsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7UUFFM0IsSUFBSSxDQUFDLElBQUksR0FBRyw0QkFBNEIsQ0FBQztRQUN6QyxNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksRUFBRSwwQkFBMEIsQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUNwRSxDQUFDO0NBQ0Y7QUFFRCxzQ0FBc0MsQ0FBQyxDQUFDLEtBQUssRUFBRSxFQUFFO0lBQy9DLElBQUksS0FBSyxZQUFZLDBCQUEwQixFQUFFLENBQUM7UUFDaEQsTUFBTSxjQUFjLEdBQUcsUUFBUSxDQUFDLFFBQVEsQ0FBQztRQUN6QyxPQUFPO1lBQ0wsS0FBSyxFQUFFO2dCQUNMLHFCQUFxQixFQUFFLEtBQUssQ0FBQyxTQUFTO2FBQ3ZDO1lBQ0QsUUFBUSxFQUFFLENBQUMsY0FBYztTQUMxQixDQUFDO0lBQ0osQ0FBQztBQUNILENBQUMsQ0FBQyxDQUFDIn0=